import React from "react";

import { WizardFooterProps } from "./types";
import Button from "../Button/Button/Button";
import { useTranslate } from "helpers";
import { ProgressBar } from "../ProgressBar";

const WizardFooter: React.FC<WizardFooterProps> = ({
  stepCurrent,
  steps,
  onNextStep,
  onBackStep,
  onFinish,
  isLoading,
  isReadOnly,
}) => {
  const { t } = useTranslate();

  return (
    <div className="border-t border-slate-200 bg-slate-50 flex-shrink-0 ">
      <ProgressBar
        value={stepCurrent + 1}
        max={steps.length}
        size="sm"
        showLabel={false}
      />

      <div className="flex justify-between px-3 py-3 ">
        <div className="flex-1 flex justify-start items-start">
          {stepCurrent > 0 && (
            <Button
              variant="outlined"
              onClick={onBackStep}
              disabled={stepCurrent === 0}
            >
              {t("admin.wizard.footer.back")}
            </Button>
          )}
        </div>
        <div className="flex-1 my-2 text-center ">
          <span className="text-gray-700 text-sm">
            {t("admin.wizard.footer.step")} {stepCurrent + 1}{" "}
            {t("admin.wizard.footer.step.of")} {steps.length}
          </span>
        </div>
        <div className="flex-1 flex justify-end items-end">
          {stepCurrent < steps.length - 1 ? (
            <Button onClick={onNextStep} variant="primary">
              {t("admin.wizard.footer.foward")}
            </Button>
          ) : (
            !isReadOnly && (
              <div>
                {isLoading ? (
                  <Button loading={true} />
                ) : (
                  <Button onClick={onFinish} variant="primary">
                    {t("admin.wizard.footer.submit")}
                  </Button>
                )}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default WizardFooter;
